import { InMemoryCache, ApolloClient } from '@apollo/client';
import { AuthorizationCookiesEnum } from 'generated/graphql';
import MarketHelper from 'helpers/MarketHelper';
import { GetServerSidePropsContext } from 'next';
import { parseContextLocale } from 'utils/parseContextLocale';

export const cache = new InMemoryCache();

export const authorizedApolloClient = async (context: GetServerSidePropsContext) => {
    const userCookie = AuthorizationCookiesEnum.MkWebshopJwt;
    const cartCookie = 'anonymous_cart';

    const { cookies } = context.req;
    const { market } = await parseContextLocale(context);
    const backendDomain = MarketHelper.getBackendDomain(market);

    return new ApolloClient({
        uri: `${backendDomain}/graphql`,
        cache,
        credentials: 'include',
        headers: { cookie: `${userCookie}=${cookies[userCookie]};${cartCookie}=${cookies[cartCookie]};` },
        defaultOptions: { query: { errorPolicy: 'all', fetchPolicy: 'no-cache' } },
    });
};
